@if(type === 'btn-fill'){
<button type="button" (click)="btnAction()" 
   [ngClass]="inputAppendClassAI ? inputAppendClassAI.join(' ') : ''"
   class="flex w-full items-center justify-center gap-2 text-nowrap rounded-lg bg-gradient-to-r from-[#792CF2] to-[#4321FC] px-6 py-3 md:w-auto">
   <svg-icon src="@assets/images/icons/sparkles-white.svg" class="btn-icon text-white"></svg-icon>
   <span class="text-sm font-medium max-sm:text-xs text-white" i18n>{{ label }}</span>
</button>
}@else if(type === 'btn-transparent'){
<button type="button" (click)="btnAction()" 
   [ngClass]="inputAppendClassAI ? inputAppendClassAI.join(' ') : ''"
   class="btn btn-sm btn-transparent hover:bg-transparent">
   <svg-icon src="@assets/images/icons/sparkles.svg" class="btn-icon"></svg-icon>
   <span class="text-sm font-medium max-sm:text-xs !text-gradient" i18n>{{ label }}</span>
</button>
}@else{
<button type="button" (click)="btnAction()" 
   [ngClass]="inputAppendClassAI ? inputAppendClassAI.join(' ') : ''"
   class="btn btn-sm btn-transparent p-0">
   <svg-icon src="@assets/images/icons/sparkles.svg" class="btn-icon"></svg-icon>
</button>
}

<common-modal #promptModal i18n-title [title]="promptLabel" customClass="w-full max-w-xl m-4">
   <ng-container content>
      @if(promptModal.isOpened){
      <div class="p-6">
         <form [formGroup]="formPrompt">
            <formly-form [form]="formPrompt" [fields]="fieldsPrompt" [model]="modelPrompt"></formly-form>
            <div class="mt-6 flex justify-end gap-4">
               <button (click)="promptModal.close()" type="button" class="btn btn-sm btn-light" i18n>Cancel</button>
               <button (click)="submitPrompt()" type="submit" class="btn btn-sm btn-primary" i18n>Generate</button>
            </div>
         </form>
      </div>
      }
   </ng-container>
</common-modal>